<template lang='pug'>
  div(id="main_sidebar" data-button-show-id="show_main_sidebar_btn" role="navigation" aria-label="Menú principal")
    div(class="sidebar")
      div(class="navbar-brand d-flex justify-content-center align-items-center sidebar-brand m-0")
        //img(class="icon-sidebar" :src="image")
        span(style="color: white")
          i(style="color: white;font-size: 30px;" class="fa-solid fa-star")
                
      slot

      div(class="text-center")
        br
        button(
          id="hide_main_sidebar_btn"
          class="btn rounded-circle border-0"
          style="border-radius: 50% !important;background-color: #ffffff78;"
          aria-label="Cerrar menú"
        )
          i(style="color: white;" class="fa-solid fa-arrow-left")
      
</template>

<script>
export default {
  data:function(){
    return {
      isMobile: false
    }
  },
  mounted(){
    this.initSidebar()
  },
  beforeDestroy(){
    // Bug 1 fix: Limpiar todos los event listeners para evitar memory leaks con Turbo
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
    if (this._escapeHandler) {
      document.removeEventListener('keydown', this._escapeHandler);
    }
    if (this._turboBeforeCacheHandler) {
      document.removeEventListener('turbo:before-cache', this._turboBeforeCacheHandler);
    }
    if (this.showButton && this._showClickHandler) {
      this.showButton.removeEventListener('click', this._showClickHandler);
    }
    if (this.hideButton && this._hideClickHandler) {
      this.hideButton.removeEventListener('click', this._hideClickHandler);
    }
    if (this._sidebarLinkHandler) {
      let sidebarEl = document.querySelector('.sidebar-section');
      if (sidebarEl) sidebarEl.removeEventListener('click', this._sidebarLinkHandler);
    }
    // Restaurar body overflow por si el drawer estaba abierto
    document.body.style.overflow = '';
  },
  props: ["image"],
  methods:{
    displaySidebar:function(elementB,selectorB){
      let self=this;
      this.elB=document.getElementById(elementB);
      this.showButton=document.getElementById(this.elB.getAttribute("data-button-show-id"));
      this.hideButton=document.getElementById(selectorB);

      // Agregar atributos ARIA al botón hamburguesa (Mejora 4)
      if (this.showButton) {
        this.showButton.setAttribute('aria-label', 'Abrir menú');
        this.showButton.setAttribute('aria-expanded', 'false');
      }
      
      // Arrow function para mantener el scope correcto
      this.handlerClick = (shouldClose) => {
        // CSS controla la visibilidad del botón hamburguesa (display:none en desktop, inline-block en móvil)
        if (self.elB) self.elB.hidden = shouldClose;

        let sidebarSection = document.querySelector('.sidebar-section');
        let backdrop = document.getElementById('sidebar-mobile-backdrop');

        if (!backdrop) {
          backdrop = document.createElement('div');
          backdrop.id = 'sidebar-mobile-backdrop';
          backdrop.className = 'sidebar-mobile-backdrop';
          backdrop.setAttribute('aria-hidden', 'true');
          document.body.appendChild(backdrop);
          backdrop.addEventListener('click', () => {
            self.handlerClick(true);
          });
        }

        if (sidebarSection) {
          if (!shouldClose) {
            // Abrir sidebar
            sidebarSection.classList.add('show');
            backdrop.classList.add('show');
            if (self.showButton) self.showButton.setAttribute('aria-expanded', 'true');
            // Bloquear scroll del body cuando el drawer está abierto
            if (window.innerWidth < 768) {
              document.body.style.overflow = 'hidden';
            }
          } else {
            // Cerrar sidebar
            sidebarSection.classList.remove('show');
            backdrop.classList.remove('show');
            if (self.showButton) self.showButton.setAttribute('aria-expanded', 'false');
            // Restaurar scroll del body
            document.body.style.overflow = '';
          }
        }
      }

      // Guardar referencias de handlers para poder limpiarlos en beforeDestroy (Bug 1)
      this._showClickHandler = () => { self.handlerClick(false); };
      this._hideClickHandler = () => { self.handlerClick(true); };
      if (this.showButton) this.showButton.addEventListener('click', this._showClickHandler);
      if (this.hideButton) this.hideButton.addEventListener('click', this._hideClickHandler);

      // Cerrar drawer al hacer clic en cualquier enlace de navegación del sidebar
      let sidebarEl = document.querySelector('.sidebar-section');
      if (sidebarEl) {
        this._sidebarLinkHandler = (e) => {
          let link = e.target.closest('a[href]');
          if (link && window.innerWidth < 768) {
            // Pequeño delay para que la navegación se inicie antes de cerrar
            setTimeout(() => {
              self.handlerClick(true);
            }, 150);
          }
        };
        sidebarEl.addEventListener('click', this._sidebarLinkHandler);
      }
    },
    initSidebar:function(){
      this.displaySidebar('main_sidebar','hide_main_sidebar_btn');
      if (window.innerWidth < 768) {
        this.handlerClick(true);
      }

      // Manejar resize en ambas direcciones
      this._resizeHandler = () => {
        let wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;

        if (wasMobile && !this.isMobile) {
          // Transición de móvil → escritorio: mostrar sidebar
          if (this.elB) this.elB.hidden = false;
          let sidebarSection = document.querySelector('.sidebar-section');
          let backdrop = document.getElementById('sidebar-mobile-backdrop');
          if (sidebarSection) sidebarSection.classList.remove('show');
          if (backdrop) backdrop.classList.remove('show');
          document.body.style.overflow = '';
        } else if (!wasMobile && this.isMobile) {
          // Transición de escritorio → móvil: ocultar sidebar (off-canvas cerrado)
          this.handlerClick(true);
        }
      };
      window.addEventListener('resize', this._resizeHandler);
      this.isMobile = window.innerWidth < 768;

      // Mejora 1: Cerrar drawer con tecla Escape
      this._escapeHandler = (e) => {
        if (e.key === 'Escape' && this.isMobile) {
          let sidebarSection = document.querySelector('.sidebar-section');
          if (sidebarSection && sidebarSection.classList.contains('show')) {
            this.handlerClick(true);
          }
        }
      };
      document.addEventListener('keydown', this._escapeHandler);

      // Mejora 5: Limpiar estado antes de que Turbo cachee la página
      this._turboBeforeCacheHandler = () => {
        let sidebarSection = document.querySelector('.sidebar-section');
        let backdrop = document.getElementById('sidebar-mobile-backdrop');
        if (sidebarSection) sidebarSection.classList.remove('show');
        if (backdrop) backdrop.classList.remove('show');
        document.body.style.overflow = '';
        if (this.showButton) this.showButton.setAttribute('aria-expanded', 'false');
      };
      document.addEventListener('turbo:before-cache', this._turboBeforeCacheHandler);
    }
  }
}
</script>


<style scoped>
  .submenu {
    padding-left: 25px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
  }

  .submenu.open {
    max-height: 500px;
  }

  .menu-item-with-submenu {
    cursor: pointer;
  }

  .menu-item-with-submenu i.fa-chevron-down {
    transition: transform 0.3s;
  }

  .menu-item-with-submenu.open i.fa-chevron-down {
    transform: rotate(180deg);
  }
</style>